import { Injectable } from '@angular/core';
import { Segment } from '@app/models/micro/segment.model';
import { Reservation } from '@app/models/micro/reservation.model';
import { GlobalsService } from './globals.service';
import {
  CHECKIN_STATUS,
  FLIGHT_ITINERARY_TYPE,
  FLIGHT_STATUS,
  PAX_TYPE,
  TypeLoading,
  ESTATUS_CHECKIN,
} from '@app/enums';
import { Router } from '@angular/router';
import { MessagesService } from '../messages.service';
import { CodesError, CodesErrorDestination, TypesErrors } from '@app/enums/errors.enum';
import {
  calculateTimeFlight,
  calculateIropsAffectationTime,
  checkSegmentIsAffected,
  resolveFlightStatusNavigation,
  validateIropsFlow,
  verifyChildAlone,
} from '@utils/functions/srIrops';
import { isStbEmployee, stbPallSeat } from '@utils/functions/stb';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from '../admin.service';
import { CussService } from '../cuss.service';
import { IROPS_STATUS } from '@app/enums/irops.enum';
import { IropsService } from '../irops.service';
import { IropsMapper } from '@app/mappers';
import { ApiService } from '@services/micro/api.service';
import { ViewDocuments } from '@models/micro/response/viewDocuments.model';
import { ErrorInt } from '@interfaces/*';
import { messageParamsGeneric } from '@app/utils';
import {
  getTypeFlowIrops,
  isClosed,
  isClosedMYB,
  isKioskDepartureAirportMismatch,
} from '@utils/functions/general';
import { evaluateSegmentDocumentation } from '@utils/functions/flight-documentation-window';
import {
  matchFlightStatusForSegment,
  FlightStatusEntryLike,
} from '@utils/functions/flight-status-matcher';
import { PassengerService } from './passenger.service';
import { combineLatest, lastValueFrom, take, tap } from 'rxjs';
import { Subscription } from 'rxjs';
import { FlightDetails } from '@models/micro/response/flightDetails.model';
import { Ga4Service } from '@app/services/ga4.service';
import { AirLinesComponent } from '@modals/air-lines/air-lines.component';
import { AmKeyboardService } from '@components/am-keyboard/am-keyboard.service';
import { LoadingService } from '../loading.service';
import { Passenger } from '@app/models/micro/passenger.model';
import { AirLineSeamless } from '@app/utils/constants/airlineSeamless';
import { AlertPremierDisclaimerComponent } from '@modals/alert-premier-disclaimer/alert-premier-disclaimer.component';
import { VerifyPassportModalComponent } from '@modals/verify-passport-modal/verify-passport-modal.component';
import { ErrorsModalCknComponent } from '@modals/errors/errors-modal-ckn/errors-modal-ckn.component';
import { LoyaltyService } from '@services/micro/loyalty.service';
import { RespBenefits } from '@models/micro/response/respBenefits.model';
import { OK_TO_BOARD } from '@app/utils/constants/generals';
import { ApiAncillaries } from '@services/micro/ancillaries.service';
import { IropsService as IropsMicroService } from './irops.service';
import { IropsRemarkParamsInt } from '@app/interfaces/micro/irops-remark-params.interface';
import { RequiredDocumentsService } from './required-documents.service';
import { messageNoCkn, messageFareFamilyEmpty } from '@app/utils';
import { PNRLookupAWSInt } from '@app/interfaces/reservation-aws.interface';
import { ErrorModel } from '@models/micro/error.model';
import { TsaBlockerModalComponent } from '@app/shared/modals/tsa-blocker-modal/tsa-blocker-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { KioskPermissionsService } from '@services/kiosk-permissions.service';
import moment from 'moment';
/**
 *Servicio para gestionar el proceso de búsqueda de PNR (Passenger Name Record), que incluye la comprobación del estado del vuelo,
 * la gestión de reservas y el manejo de casos especiales como pasajeros en lista de espera, pasajeros menores de edad y operaciones irregulares (IROPS).
 * Este servicio interactúa con varias API para obtener detalles del vuelo, documentos y listas de pasajeros, así como para mostrar los modales apropiados
 * y redirigir al usuario a la página correspondiente en función del estado del vuelo y los pasajeros.
 *
 */

/**
 * Decisión de documentación del `currentSegment` (CI-22450). Tipada y explícita
 * para no depender de booleanos ambiguos que puedan contradecirse.
 */
type DocumentationDecision =
  | 'ALLOW'
  | 'BLOCK_UNCONFIRMED'
  | 'BLOCK_CANCELLED'
  | 'BLOCK_BEFORE_OPEN'
  | 'BLOCK_BOARDING'
  | 'BLOCK_CLOSED'
  | 'BLOCK_INVALID'
  | 'PRESERVE_LEGACY';

/**
 * Equivalencia entre el estatus operativo de Flight Status (IROPS_STATUS) y el
 * estatus de vuelo del leg (FLIGHT_STATUS). Centralizado para que el mapeo del
 * `currentSegment` y el lookup por `segmentCode` no puedan divergir.
 */
const FLIGHT_STATUS_BY_IROPS_STATUS: Record<string, FLIGHT_STATUS> = {
  [IROPS_STATUS.SCHEDULED]: FLIGHT_STATUS.ON_TIME,
  [IROPS_STATUS.DELAYED]: FLIGHT_STATUS.DELAYED,
  [IROPS_STATUS.EARLY]: FLIGHT_STATUS.DELAYED,
  [IROPS_STATUS.CANCELLED]: FLIGHT_STATUS.CANCELLED,
};

@Injectable({
  providedIn: 'root',
})
export class LookUpPnrService {
  reservation: Reservation | null = null;
  selectedSegment: Segment | null = null;
  pnrLookupFailureCount = 0;
  showModalIrops = false;
  redirect: boolean = false;
  subscribeReference: Subscription;
  respEligibleIrops: any;
  reservationInt: PNRLookupAWSInt;
  environment = environment;
  shouldBlockByMissingPassengerIds = false;

  constructor(
    private _globalService: GlobalsService,
    private _router: Router,
    private _message: MessagesService,
    private modalService: NgbModal,
    private _adminService: AdminService,
    private _cussService: CussService,
    private _iropsService: IropsService,
    private _apiService: ApiService,
    private _loyatlyService: LoyaltyService,
    private _passengerService: PassengerService,
    private _ga4Service: Ga4Service,
    private _keyboardServ: AmKeyboardService,
    private _loadingService: LoadingService,
    private _ApiAncillaries: ApiAncillaries,
    private _iropsMicroService: IropsMicroService,
    private _requiredDocuments: RequiredDocumentsService,
    private _traslateService: TranslateService,
    private _kioskPermissions: KioskPermissionsService
  ) {}
  /**
  Realiza una serie de operaciones relacionadas con la búsqueda y procesamiento de una reserva de vuelo (PNR).
  Esta función configura sesiones en herramientas de análisis, valida la aerolínea operadora, realiza solicitudes
  a microservicios para obtener información adicional, gestiona el estado de check-in y determina la redirección
  basada en el tipo de itinerario.

  @param lookUp Un arreglo de objetos de tipo `Reservation` que contiene la información de la reserva de vuelo.
  @return No retorna ningún valor explícito, pero realiza redirecciones y actualizaciones en servicios globales.
**/

  successLookUpPnr = async (lookUp: Reservation[]) => {
    try {
      const { Location } = this._adminService.admin;
      const { hasConfirmed } = this._iropsMicroService;

      if (this.validInternationalBlock(lookUp[0])) {
        this.openModalInternationalBlocked();
        /*this._message.error({}, '', TypesErrors.TSA_VALIDATION, {
        colorFontButton: "white-font",
        buttonCopy: 'footer.continue'
      }).finally(() => {
        this._router.navigate(['/'])
      })*/
        //this.ngOnDestroy();
        return;
      }

      if (this.hasFareFamilyEmptyError(lookUp[0])) {
        this.handleFareFamilyEmptyError();
        return;
      }

      this._ga4Service.sendSessionStarEvent('session_start_am', 'PNR_lookup');
      // Activa Seamless
      if (lookUp[0]?.flightSummary?.operatingCarrier !== 'AM' && !this.isSeamless(lookUp[0])) {
        this.openCodeInfoModal(lookUp[0]?.flightSummary?.operatingCarrier);
        this.ngOnDestroy();
        return;
      }

      if (this.blockFlowIfKioskDepartureMismatch(lookUp[0], Location, lookUp)) {
        return;
      }

      this._globalService.setPNRLookUp(lookUp);
      this.reservation = lookUp[0];
      this._globalService.setReservation(this.reservation);
      this._adminService.admin.cartId = this.reservation.flightSummary.cartId;

      if (this.validateVoidTicket(this.reservation)) {
        this._message
          .errorNoCkin(
            {
              typesError: TypesErrors.CHECKIN_ERROR,
              error: {
                message: '',
              },
            },
            null,
            TypesErrors.CHECKIN_ERROR,
            messageNoCkn,
            '',
            false
          )
          .finally(() => {
            this._router.navigate(['']);
          });
        return;
      }
      if (
        isClosedMYB(this.reservation.flightSummary, this.reservation.flightSummary.currentSegment)
          .status === true
      ) {
        const childRoute = this.isChildAlone(this.reservation?.passengers);
        if (childRoute) {
          this._router.navigate([childRoute]);
          return;
        }
        const response = await this._requiredDocuments.getViewDocuments(
          this.reservation,
          this.successGetDocuments.bind(this),
          '/'
        );
        if (!response) {
          this.openModalErrorDocuments();
          return;
        }
        this._router.navigate(['/notice-myb-closed']);
        return;
      }

      const flowIrops = getTypeFlowIrops(this.reservation);

      // CI-22450 (pre-mapeo): sólo se bloquea lo que NO puede esperar a Flight
      // Status. Un SC/WK debe detenerse aquí para no entrar a /srIrops/* a
      // confirmar cambios desde SSBD, y un Cancelled ya conocido es terminal.
      // Los estados de ventana (BOARDING/CLOSED/INVALID) se posponen a después
      // del mapeo: si se resolvieran aquí, un vuelo realmente cancelado se
      // mostraría como "Vuelo en abordaje"/"Vuelo cerrado" en vez de Cancelado.
      const preMappingDecision = this.resolveDocumentationDecision();
      if (preMappingDecision === 'BLOCK_CANCELLED' || preMappingDecision === 'BLOCK_UNCONFIRMED') {
        if (this.handleTerminalDecision(preMappingDecision)) {
          return;
        }
      }

      if (flowIrops) {
        if (flowIrops === 'commercial') {
          try {
            this.respEligibleIrops = await this.dispatchEligibilityIrops();
            this.dispatchIropsRemarkIfEligible();
          } catch (error) {
            this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
          }
          this._router.navigate(['/srIrops/iropsRebrand']);
          return;
        } else {
          // Agregar a función Try y eliminar este else
          try {
            const requestMicro = IropsMapper.requestIropsMicro(lookUp);

            const responseMicro = await this._iropsService.makeRequestIropsMicro(requestMicro);

            if (!responseMicro || responseMicro.length === 0) {
              throw new Error('No se recibió respuesta válida del Micro IROPS');
            }

            this.constructFlight(responseMicro, lookUp);
          } catch (error) {
            this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
          }
        }
      }

      // CI-22450 (post-mapeo): decisión definitiva con Flight Status ya mapeado
      // y el ETD real aplicado a la ventana. Cancelled tiene prioridad absoluta
      // dentro de `resolveDocumentationDecision`. Los efectos (persistir +
      // navegar) los ejecuta una sola vez `handleTerminalDecision`.
      const documentationDecision = this.resolveDocumentationDecision();
      if (this.handleTerminalDecision(documentationDecision)) {
        return;
      }
      const docWindowAllows =
        documentationDecision === 'ALLOW' || documentationDecision === 'BLOCK_BEFORE_OPEN';

      // CVT20-13930/13932: bloqueo terminal por estatus de vuelo. La fuente autoritativa
      // es currentSegment.flightsNewInfo.status (mapeada desde flightStatusCollection).
      // Delayed<45/Early<45 → /notice-closed terminal; Delayed/Early>=45 → IROPs
      // si está disponible, si no /notice-closed. Scheduled/OnTime → flujo normal existente.
      // CI-22450: se omite cuando la ventana ya autorizó un HK (OPEN/BEFORE_OPEN),
      // porque un HK no debe re-bloquearse por la cantidad de minutos. Cancelled
      // ya quedó bloqueado antes, así que esta omisión nunca lo alcanza.
      if (!docWindowAllows && this.applyFlightStatusTerminalBlock(Location, hasConfirmed)) {
        return;
      }

      // AQUI ED CODE
      /*
      if (IGUAL a CLOSED  &&  Si tiene afectación && banderaDeYisus/remark )
      {
        //setear flightSummary y currentSegment
        //flowIrops === 'operational'
      }
    */

      if (
        flowIrops === 'operational' &&
        validateIropsFlow(this.reservation, Location, hasConfirmed)
      ) {
        try {
          this.respEligibleIrops = await this.dispatchEligibilityIrops();
          this.dispatchIropsRemarkIfEligible();
        } catch (error) {
          this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
        }
      }
      const mybStatus = isClosedMYB(this.reservation.flightSummary);
      // const mybStatus = isClosedMYB(this.reservation.flightSummary, this.reservation.flightSummary.currentSegment);
      if (mybStatus.status === true) {
        if (this.redirect) {
          this._globalService.isFlowMYBClosed = false;
          this._router.navigate(['/notice-myb-closed']);
        }
        return;
      }

      const { flightItineraryType } = this.reservation;
      if (this.reservation.checkinStatus !== CHECKIN_STATUS.CLOSED) {
        const response = await this._requiredDocuments.getViewDocuments(
          this.reservation,
          this.successGetDocuments.bind(this),
          '/'
        );
        if (!response) {
          this.openModalErrorDocuments();
          return;
        }
        await this.loadStb(this.reservation);
      }
      let urlDirect = '';

      switch (flightItineraryType) {
        case FLIGHT_ITINERARY_TYPE.ONEWAY:
          if (
            validateIropsFlow(this.reservation, Location, hasConfirmed) &&
            this._adminService.admin.showIrops
          ) {
            this._globalService.setReservation(this.reservation);
            const segmentCancelled = this.segCancelled;
            const segmentAfected = this.segAfected;
            const timeAfected = calculateIropsAffectationTime(segmentAfected);

            // Validación según el status
            const shouldShowIrops =
              segmentAfected?.flightsNewInfo?.status === IROPS_STATUS.EARLY
                ? timeAfected.minutes >= 15 || timeAfected.hours > 0 // EARLY: >= 15 min
                : timeAfected.minutes >= 30 || timeAfected.hours > 0; // DELAYED: >= 30 min

            urlDirect = '/srIrops/iropsRebrand';

            if (
              !segmentCancelled &&
              segmentAfected &&
              !this.reservation?.isEmployee &&
              this.respEligibleIrops &&
              !this.respEligibleIrops?.exchangesAllowed
            ) {
              if (!shouldShowIrops) {
                urlDirect = '/choose-passagers';
              } else {
                urlDirect = '/srIrops/noElegibleSR';
              }
            } else if (
              segmentCancelled &&
              !this.reservation?.isEmployee &&
              this.respEligibleIrops &&
              !this.respEligibleIrops?.exchangesAllowed
            ) {
              this.reservation.iropsElegibility = this.respEligibleIrops?.exchangesAllowed;
              this._globalService.setReservation(this.reservation);
            } else {
              const validIsClosed = isClosed(
                this.reservation.flightSummary,
                this.reservation.flightSummary.currentSegment
              );

              if (segmentAfected && !shouldShowIrops) {
                if (this.reservation.checkinStatus === CHECKIN_STATUS.CLOSED) {
                  urlDirect = validIsClosed ? '/notice-closed-onboarding' : '/notice-closed';
                } else {
                  const response = await this._requiredDocuments.getViewDocuments(
                    this.reservation,
                    this.successGetDocuments.bind(this),
                    '/'
                  );
                  if (!response) {
                    this.openModalErrorDocuments();
                    return;
                  }
                  await this.loadStb(this.reservation);
                  urlDirect = this.validatePassengersCki();
                }
              }
            }
          } else {
            const trip: Segment = lookUp[0].flightSummary.segments[0];
            this._globalService.setSelectedTrip(trip);
            urlDirect = await this.redirectCases(this.reservation, lookUp);
          }
          break;
        case FLIGHT_ITINERARY_TYPE.ROUNDTRIP:
        case FLIGHT_ITINERARY_TYPE.MULTICITY: {
          const openTrips = lookUp[0].checkinStatus === 'OPEN' ? lookUp : null;
          const tripSelected: Segment | null = lookUp.reverse()[0].flightSummary.segments[0];
          this._globalService.setSelectedTrip(tripSelected);
          if (openTrips?.length > 1) {
            this._globalService.isMultiFlights = true;
            urlDirect = '/choose-passagers';
          } else {
            if (openTrips?.length > 0) {
              this._globalService.setReservation(openTrips[0]);
            }
            urlDirect = await this.redirectCases(this.reservation, lookUp);
          }
          break;
        }
      }
      if (this.redirect) {
        if (this.handleMissingPassengerIdsBlock()) {
          return;
        } else {
          this._router.navigate([urlDirect]);
        }
      }
    } catch (error) {
      console.warn('[LookUpPnr] Error in successLookUpPnr:', error);
    } finally {
      this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
    }
  };

  /**
   * CI-22450: calcula la decisión de documentación del `currentSegment` SIN
   * efectos secundarios (no persiste, no navega, no termina). Puede invocarse
   * varias veces —antes y después del mapeo de Flight Status— sin duplicar
   * `setReservation` ni navegación. Los efectos viven en
   * `handleTerminalDecision`.
   *
   * Prioridad: Cancelled → SC/WK → ventana → legacy.
   */
  private resolveDocumentationDecision(): DocumentationDecision {
    const currentSegment = this.reservation?.flightSummary?.currentSegment;
    const { eligibility } = evaluateSegmentDocumentation(currentSegment);

    // Cancelled primero y sin condiciones: prevalece sobre SC/WK y sobre
    // cualquier estado de ventana (BEFORE_OPEN/BOARDING/CLOSED/INVALID), para
    // que /notice-closed siempre muestre la variante Cancelled.
    if (currentSegment?.flightsNewInfo?.status === IROPS_STATUS.CANCELLED) {
      return 'BLOCK_CANCELLED';
    }

    switch (eligibility) {
      case 'BLOCK_CANCELLED':
        return 'BLOCK_CANCELLED';
      case 'BLOCK_UNCONFIRMED':
        return 'BLOCK_UNCONFIRMED';
      case 'BOARDING':
        return 'BLOCK_BOARDING';
      case 'CLOSED':
        return 'BLOCK_CLOSED';
      case 'BLOCK_INVALID':
        return 'BLOCK_INVALID';
      case 'BLOCK_BEFORE_OPEN':
        return 'BLOCK_BEFORE_OPEN';
      case 'ALLOW':
        return 'ALLOW';
      default:
        return 'PRESERVE_LEGACY';
    }
  }

  /**
   * CI-22450: único ejecutor de los efectos de una decisión terminal. Persiste la
   * reservación exactamente una vez y navega exactamente una vez a
   * `/notice-closed` cuando `redirect` es `true` (sin `forceClosedVariant`: la
   * pantalla deriva la variante desde el `currentSegment`). Con `redirect=false`
   * procesa y detiene sin navegar, conservando el contrato existente.
   *
   * Devuelve `true` cuando el flujo debe terminar. `BLOCK_BEFORE_OPEN` NO es
   * terminal: el pasajero continúa al flujo normal con el contador "Disponible
   * en", y el avance a equipaje/pago queda bloqueado por `disabledBaggageDrop`.
   */
  private handleTerminalDecision(decision: DocumentationDecision): boolean {
    const terminalDecisions: DocumentationDecision[] = [
      'BLOCK_CANCELLED',
      'BLOCK_UNCONFIRMED',
      'BLOCK_BOARDING',
      'BLOCK_CLOSED',
      'BLOCK_INVALID',
    ];

    if (!terminalDecisions.includes(decision)) {
      return false;
    }

    this._globalService.setReservation(this.reservation);
    if (this.redirect) {
      this._router.navigate(['/notice-closed']);
    }
    return true;
  }

  /**
   * CVT20-13930/13932: aplica la decisión terminal por estatus de vuelo antes de
   * permitir pasajeros/equipaje. Devuelve `true` cuando el flujo debe finalizar en
   * `/notice-closed` (la pantalla resuelve la variante desde flightsNewInfo.status,
   * sin forceClosedVariant). Devuelve `false` para dejar continuar el flujo IROPs
   * o el flujo normal existentes.
   *
   * CI-22450: ya no decide sobre Cancelled; ese caso lo resuelve antes
   * `resolveDocumentationDecision` con prioridad absoluta.
   */
  private applyFlightStatusTerminalBlock(location: string, hasConfirmed: boolean): boolean {
    const currentSegment = this.reservation?.flightSummary?.currentSegment;
    const status = currentSegment?.flightsNewInfo?.status;

    const iropsAvailable =
      validateIropsFlow(this.reservation, location, hasConfirmed) &&
      this._adminService.admin.showIrops;

    const { totalMinutes } = calculateIropsAffectationTime(currentSegment);

    const decision = resolveFlightStatusNavigation(status, totalMinutes, iropsAvailable);

    if (decision !== 'terminal') {
      return false;
    }

    this._globalService.setReservation(this.reservation);
    if (this.redirect) {
      this._router.navigate(['/notice-closed']);
    }
    return true;
  }

  get segCancelled() {
    return this.reservation.flightSummary.segments.find(
      (seg) => checkSegmentIsAffected(seg) && seg?.flightsNewInfo?.status === IROPS_STATUS.CANCELLED
    );
  }

  get segAfected() {
    const acceptStatus = ['CKI', 'MYB', 'IN_FLIGHT', 'CLOSED'];
    return this.reservation.flightSummary.segments.find(
      (seg) =>
        checkSegmentIsAffected(seg) &&
        (seg?.flightsNewInfo?.status === IROPS_STATUS.DELAYED ||
          seg?.flightsNewInfo?.status === IROPS_STATUS.EARLY) &&
        acceptStatus.includes(seg?.windowSegmentStatus)
    );
  }

  /**
  Maneja los errores que ocurren durante la búsqueda de un PNR (Reserva de Vuelo).
  Esta función identifica el tipo de error basado en la respuesta recibida, construye un objeto de error
  y muestra un mensaje de error apropiado al usuario.

  @param error Objeto que contiene la información del error ocurrido durante la búsqueda del PNR.
  @param pnr El código PNR (Reserva de Vuelo) que se estaba buscando cuando ocurrió el error.
**/

  errorLookUpPnr = (error: ErrorModel, pnr: string) => {
    let codeError = '';

    // Verificar si es una excepción FARELOCK en los datos raw
    if (error?.getRaw()?.typeReservation === 'FARELOCK') {
      this._message.errorMessage({ typesError: TypesErrors.FARELOCK_ERROR }, () => {
        this._router.navigate(['/']);
      });
      return;
    }

    if (error?.getMessage()?.includes('NOT_FOUND')) {
      codeError = '204131-2';
    }
    if (error?.getMessage()?.includes('MANY')) {
      codeError = '204131-1';
    }

    if (error?.getMessage()?.includes('NO_RESERVATIONS')) {
      codeError = '204131';
    }
    error.withCode(codeError);

    const objError: ErrorInt = {
      error: {
        code: codeError,
      },
      code: codeError,
    };

    if (this.isCodeError(codeError)) {
      this._message.errorMessageDestination({ error });
    } else if (this.isCodeErrorDestination(codeError)) {
      this._message.errorMessageDestination({ error });
      this._message.printErrorCard(TypesErrors.DEST_SEARCH_FAIL, error);
    } else {
      this._message.error(
        { typesError: TypesErrors.RESERVATION_NOT_FOUND, error },
        error.getCode(),
        TypesErrors.RESERVATION_NOT_FOUND,
        messageParamsGeneric
      );
    }
  };

  private isCodeError(code: string): code is CodesError {
    return Object.values(CodesError).includes(code as CodesError);
  }

  /**
   * el leg/segmento correcto debe resolverse en mapper y FlightSummary.
   * Evita continuar el flujo SSBD si el segmento activo no sale del aeropuerto del kiosko.
   */
  private blockFlowIfKioskDepartureMismatch(
    reservation: Reservation,
    kioskLocation: string,
    lookUp: Reservation[]
  ): boolean {
    if (!isKioskDepartureAirportMismatch(reservation.flightSummary, kioskLocation)) {
      return false;
    }

    this._globalService.setPNRLookUp(lookUp);
    this.reservation = reservation;
    this._globalService.setReservation(reservation);
    this._adminService.admin.cartId = reservation.flightSummary?.cartId;

    this._router.navigate(['/notice-closed'], { state: { forceClosedVariant: true } });
    return true;
  }

  private isCodeErrorDestination(code: string): code is CodesErrorDestination {
    return Object.values(CodesErrorDestination).includes(code as CodesErrorDestination);
  }

  /**
   * Evalúa si, para la Reservation activa (lookUp[0]), FARE_FAMILY
   * (flightSummary.fareFamily o flightSummary.currentSegment.fareFamily) es
   * nulo, indefinido, o una cadena vacía/compuesta únicamente por espacios en
   * blanco.
   */
  private hasFareFamilyEmptyError(reservation: Reservation): boolean {
    const isEmpty = (value: string | null | undefined): boolean =>
      value === null || value.trim().length === 0;

    return (
      isEmpty(reservation.flightSummary?.fareFamily) ||
      isEmpty(reservation.flightSummary?.currentSegment?.fareFamily)
    );
  }

  sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay));

  /**
  Obtiene los detalles de un vuelo específico asociado a una reserva y actualiza la información de los segmentos de la reserva.
  Esta función realiza una solicitud para obtener los detalles del vuelo y, si tiene éxito, actualiza la información
  de los segmentos de la reserva con los datos del estado del vuelo.

  @param reservation Un objeto de tipo `Reservation` que representa la reserva de vuelo para la cual se obtendrán los detalles.
  @return No retorna ningún valor explícito, pero actualiza la reserva en el servicio global.
**/

  getFlightDetails(reservation: Reservation) {
    this._apiService.getFlightDetails(reservation).subscribe({
      next: (res) => {
        let reponse = new FlightDetails(res);
        for (let segment of reservation.segments) {
          const segmentAct = reponse.bookedLegCollection.find(
            (p) => p.segmentCode === segment.segmentCode
          );
          if (segmentAct) {
            const cabinInfo = segmentAct.cabinInfoList.find((p) => p.classOfService === 'Y');
            segment.cabinInfo = cabinInfo;
            segment.flightStatus = segmentAct.flightStatus;
          }
        }
        this._globalService.setReservation(reservation);
      },
      error: (error: ErrorModel) => {
        this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
        this._message.printErrorCard(
          error.getCodeNumber(),
          error,
          reservation.pnr,
          reservation,
          reservation.passengers,
          error.getMessage()
        );
      },
      complete: () => {},
    });
  }

  /**
   * Obtiene y asigna los documentos requeridos para la reserva.
   *
   * @param {Reservation} reservation - Objeto de la reserva actual.
   * @returns {Promise<boolean>} - Promesa que se resuelve en `true` si el proceso es exitoso, de lo contrario se rechaza con `false`.
   */

  successGetDocuments(res) {
    let reponse = new ViewDocuments(res);
    const isDomestic = this.reservation?.flightSummary.isDomestic || false;
    const bookedLegCollection = reponse?.bookedLegCollection.find(
      (book) => book.legCode === this.reservation.flightSummary.legCode
    );
    const codeShare = bookedLegCollection?.codeShare || false;

    //#region set Reservartion seamless
    this.reservation.codeShare = codeShare;

    this.shouldBlockByMissingPassengerIds = this.hasNoPassengerIdsForAllPassengers(reponse);

    this.reservation.travelPartyId = reponse.travelPartyId;
    this.reservation.mandates = reponse.mandates;
    this.reservation.trips = reponse.trips;
    //#endregion set Reservartion seamless

    //#region set Leg seamless
    this.reservation.flightSummary.codeShare = codeShare;
    this.reservation.flightSummary.sdsProvider = bookedLegCollection.sdsProvider;
    this.reservation.flightSummary.serviceCodeShareEnable =
      bookedLegCollection.serviceCodeShareEnable;
    //#endregion set Leg seamless
    let passengerId;
    for (let passeger of this.reservation.passengers) {
      const passegerdoc = reponse.passengers.find(
        (p) => p.passengerNameNumber === passeger.nameRefNumber
      );
      //set passenger seamless
      if (this.reservation.codeShare) {
        passeger.passengerIdSkyteam = passegerdoc?.passengerIdSkyteam;
        passengerId = passeger.id;
        passeger.passengerIds = [];
        passeger.sourceMissing = passegerdoc.sourceMissing;

        passeger.checkinStatus = passegerdoc.checkinStatus === 'CHECKED_IN';
        passeger.passengerInfo.destinationAddress = passegerdoc.destinationAddress;
        passeger.passengerInfo.contactEmergency = passegerdoc.contactEmergency;
        passeger.passengerInfo.passport = passegerdoc.passport?.expirationDate
          ? passegerdoc.passport
          : undefined;
        passeger.passengerInfo.timaticRQ = passegerdoc.timaticRQ;
        passeger.passengerInfo.residenceAddress = passegerdoc.residenceAddress;
        passeger.passengerInfo.visa = passegerdoc.visa;
        passeger.passengerInfo.countryResidence = passegerdoc.countryResidence;
      } else {
        //set passenger not seamless
        passengerId =
          passegerdoc?.passengerIds.find(
            (ids) =>
              ids.segmentCode === this.reservation?.flightSummary?.currentSegment?.segmentCode
          )?.id || passegerdoc.passengerIds[0]?.id;
        passeger.passengerIds = passegerdoc.passengerIds;
      }
      passeger.passengerInfo.timaticRQ = passegerdoc.timaticRQ;
      passeger.missingCheckinRequiredFields = [];
      passeger.passengerId = passengerId;
      passeger.freeTextInfoList = passegerdoc.freeTextInfoList;
      passeger.requiredInfoList = passegerdoc.requiredInfoList;
      passeger.sprinklr = passegerdoc?.sprinklr;
      if (!isDomestic) {
        this._passengerService.buildMissingCheckinRequiredFields(passeger, passegerdoc, reponse);

        if (passegerdoc?.timaticInfoList?.length > 0) {
          if (passegerdoc?.timaticInfoList[0]?.timaticStatus === OK_TO_BOARD) {
            passeger.isOkToBoard = true;
          }
        }
      }
    }
    this._globalService.setReservation(this.reservation);
  }

  /**
  Determina la ruta de redirección basada en el estado de la reserva y otras condiciones.
  Esta función evalúa múltiples condiciones relacionadas con el estado de la reserva, como el flujo IROPS,
  el estado de check-in, la ubicación, la presencia de menores no acompañados, y si la reserva es en modo standby.
  Dependiendo de estas condiciones, devuelve la ruta correspondiente para redirigir al usuario.

  @param reservation Un objeto de tipo `Reservation` que representa la reserva actual.
  @param lookUp Un arreglo que contiene la lista de reservas o información adicional relacionada.
  @return Una cadena que representa la ruta a la que se debe redirigir al usuario.
**/

  private async redirectCases(reservation: Reservation, lookUp: any) {
    this._globalService.isFlowMYBClosed = false;
    const { Location } = this._adminService.admin;
    const { hasConfirmed } = this._iropsMicroService;
    const validateIropsFlow_ = validateIropsFlow(reservation, Location, hasConfirmed);

    if (validateIropsFlow_ && this._adminService.admin.showIrops) {
      this._globalService.setReservation(reservation);
      const segmentCancelled = this.segCancelled;
      const segmentAfected = this.segAfected;
      const timeAfected = calculateIropsAffectationTime(segmentAfected);
      // Validación específica según el status
      const shouldShowIrops =
        segmentAfected?.flightsNewInfo?.status === IROPS_STATUS.EARLY
          ? timeAfected.minutes >= 15 || timeAfected.hours > 0 // EARLY: >= 15 min
          : timeAfected.minutes >= 30 || timeAfected.hours > 0; // DELAYED: >= 30 min

      if (
        !segmentCancelled &&
        segmentAfected &&
        !this.reservation?.isEmployee &&
        this.respEligibleIrops &&
        !this.respEligibleIrops?.exchangesAllowed
      ) {
        if (!shouldShowIrops) {
          return '/choose-passagers';
        } else {
          return '/srIrops/noElegibleSR';
        }
      } else if (
        segmentCancelled &&
        !this.reservation?.isEmployee &&
        this.respEligibleIrops &&
        !this.respEligibleIrops?.exchangesAllowed
      ) {
        this.reservation.iropsElegibility = this.respEligibleIrops?.exchangesAllowed;
        this._globalService.setReservation(this.reservation);
      } else {
        const validIsClosed = isClosed(
          this.reservation.flightSummary,
          this.reservation.flightSummary.currentSegment
        );

        if (segmentAfected && !shouldShowIrops) {
          if (this.reservation.checkinStatus === CHECKIN_STATUS.CLOSED) {
            return validIsClosed ? '/notice-closed-onboarding' : '/notice-closed';
          } else {
            const response = await this._requiredDocuments.getViewDocuments(
              this.reservation,
              this.successGetDocuments.bind(this),
              '/'
            );
            if (!response) {
              this.openModalErrorDocuments();
              return '';
            }
            await this.loadStb(this.reservation);
            return this.validatePassengersCki();
          }
        }
      }

      return '/srIrops/iropsRebrand';
    } else if (
      isClosedMYB(reservation.flightSummary, reservation.flightSummary.currentSegment).status ===
      true
    ) {
      const childRoute = this.isChildAlone(reservation?.passengers);
      if (childRoute) return childRoute;
      const response = await this._requiredDocuments.getViewDocuments(
        this.reservation,
        this.successGetDocuments.bind(this),
        '/'
      );
      if (!response) {
        this.openModalErrorDocuments();
        return '';
      }
      return '/notice-myb-closed';
    } else if (
      reservation.checkinStatus === CHECKIN_STATUS.CLOSED ||
      isClosed(reservation.flightSummary, reservation.flightSummary.currentSegment)
    ) {
      return isClosed(reservation.flightSummary, reservation.flightSummary.currentSegment)
        ? '/notice-closed-onboarding'
        : '/notice-closed';
    } else {
      const childRoute = this.isChildAlone(reservation?.passengers);
      if (childRoute) return childRoute;
    }

    if (reservation.isStandBy === true) {
      if (stbPallSeat) {
        return this.validatePassengersCki();
      } else {
        if (isStbEmployee(this.reservation)) {
          return '/stb/employeeStbExit';
        } else {
          return '/stb/noticeBoardingpass';
        }
      }
    } else if (lookUp.length > 1) {
      return '/choose-passagers';
    } else {
      this._globalService.isMultiFlights = lookUp.length > 1;
      if (this.validateToMenu()) {
        this.onSelectAllPaseengers(true);
        if (
          this._kioskPermissions.hasPermission('enabledVerifyPassportFlowModal') &&
          !this.isDocVerifyPassengers()
        ) {
          this.openModalVerifyPassport();
        }
        if (this.reservation.codeShare) {
          return '/seamless/menu';
        } else {
          return 'rbmenuPassengerSelection';
          // return '/review-bags/pasenger-selection';
        }
      } else {
        // this.getBenefits(this.reservation.passengers[0],this.reservation)
        const passenger = this.reservation.passengers[0];
        if (this.hasPassengersFFN(passenger)) {
          this.getAssosiateFFN(this.reservation.passengers[0], this.reservation);
        }
        return '/choose-passagers';
      }
    }
  }

  isDocVerifyPassengers() {
    let isDocVerify = false;
    let contador = 0;
    const isDomestic = this.reservation?.flightSummary.isDomestic || false;
    if (!isDomestic) {
      this.reservation.passengers.forEach((element) => {
        if (element.passengerInfo?.passport?.passportScanned) {
          contador++;
        }
      });
      if ((contador = this.reservation.passengers.length)) {
        isDocVerify = true;
      }
    } else {
      isDocVerify = true;
    }
    return isDocVerify;
  }

  validatePassengersCki() {
    let route = '/choose-passagers';
    if (this.validateToMenu()) {
      this.onSelectAllPaseengers(true);
      route = 'rbmenuPassengerSelection';
      //  route = '/review-bags/pasenger-selection';
    }
    return route;
  }
  showBoaringpass() {
    return false;
  }

  goHome() {
    this._router.navigate(['/']);
  }

  openModalVerifyPassport(): void {
    const modalRef = this.modalService.open(VerifyPassportModalComponent, {
      fullscreen: true,
      centered: true,
      keyboard: false,
      backdrop: false,
    });
    modalRef.componentInstance.titleError = 'modalVerPass.title';
    modalRef.componentInstance.msgError = 'modalVerPass.subtitle';
    modalRef.componentInstance.printCard = '';
    modalRef.componentInstance.codeError = '';
    modalRef.componentInstance.uuidError = '';
    modalRef.componentInstance.backgroundColorModal = 'am-blue-premium';
    modalRef.componentInstance.showButton = true;
    modalRef.componentInstance.buttonCopy = 'modalVerPass.btverify';
    modalRef.componentInstance.showIconImage = false;
    modalRef.componentInstance.colorFontButton = 'blue-font';
    modalRef.componentInstance.backGroundButton = 'search-bg';
    modalRef.componentInstance.sizeModal = 'sd';
    modalRef.componentInstance.fontWeightTitleError = '500';
    //modalRef.componentInstance.image = './assets/images/img_ver_pass.svg';
    modalRef.componentInstance.showCancelButton = false;
    modalRef.componentInstance.cancelButtonText = '';
    //this.modalRef = modalRef
  }

  validationCancel(reservation) {
    let valid = false;
    if (reservation.checkinStatus === 'CLOSED') {
      this._globalService.setReservation(reservation);
      valid = true;
    }
    return valid;
  }

  orderArray(openTrips) {
    openTrips.sort((a, b) => {
      if (a.flightSummary.departureDateTime < b.flightSummary.departureDateTime) {
        return -1;
      }
      if (a.flightSummary.departureDateTime > b.flightSummary.departureDateTime) {
        return 1;
      }
      return 0;
    });
    return openTrips;
  }

  /**
  Construye y actualiza la información de los vuelos en las reservas basándose en la respuesta del estado de los vuelos.
  Esta función itera sobre las reservas y los segmentos de vuelo, comparándolos con la información de estado de vuelo
  proporcionada. Actualiza los segmentos con nueva información, como cambios en horarios, cancelaciones y estado del vuelo.

  @param responseFlightStatus Un arreglo de objetos que contiene la información del estado de los vuelos.
  @param lookUp Un arreglo de objetos de tipo `Reservation` que representa las reservas a actualizar.
**/
  constructFlight(responseFlightStatus: any[], lookUp: Reservation[]) {
    const { currentSegment } = this.reservation.flightSummary;

    for (let [i, reservation] of lookUp.entries()) {
      for (let rfSegment of responseFlightStatus) {
        const flightStatusSeg: FlightStatusEntryLike[] = rfSegment?.flightStatusCollection ?? [];
        const pnrSegments = reservation?.flightSummary?.segments ?? [];

        // CI-22450: cada segmento resuelve su propia entrada con el matcher
        // determinista. Antes se tomaba `flightStatusCollection[0]` y se buscaba
        // el segmento con un OR por número de vuelo, lo que podía asociar el
        // estatus al segmento equivocado (multisegmento, codeshare, misma fecha)
        // e ignoraba el resto de la colección.
        for (const findSegment of pnrSegments) {
          const segmentStatus = matchFlightStatusForSegment(findSegment, flightStatusSeg).entry;

          if (!segmentStatus) {
            continue;
          }

          // El estatus resuelto se calcula en una variable local: las entradas de
          // la colección se comparten entre iteraciones y no deben mutarse.
          let resolvedStatus = segmentStatus.status;

          // Si el status no indica afectación, comparar tiempos estimados vs originales
          if (!['Delayed', 'Early', 'Cancelled'].includes(resolvedStatus)) {
            const estimated = new Date(segmentStatus.estimatedDepartureTime).getTime();
            const original = new Date(segmentStatus.originalDepartureTime).getTime();
            if (estimated && original && estimated !== original) {
              resolvedStatus = estimated > original ? IROPS_STATUS.DELAYED : IROPS_STATUS.EARLY;
            }
          }
          resolvedStatus = this.validStatusIrops(resolvedStatus);
          findSegment.isChangeOag =
            resolvedStatus === IROPS_STATUS.DELAYED || resolvedStatus === IROPS_STATUS.EARLY;
          findSegment.isCancelOag = resolvedStatus === IROPS_STATUS.CANCELLED;

          const fNInfo = {
            arrivalDateTime: segmentStatus?.estimatedArrivalTime || '',
            departureDateTime:
              segmentStatus?.originalDepartureTime || segmentStatus?.estimatedDepartureTime || '',
            estimatedDepartureTime: segmentStatus?.estimatedDepartureTime || '',
            flightNumber: segmentStatus?.marketingFlightCode || '',
            originalDepartureTime: segmentStatus?.originalDepartureTime,
            status: resolvedStatus,
            departureDifferenceInMinutes: segmentStatus?.departureDifferenceInMinutes,
          };

          findSegment.flightsNewInfo = fNInfo;

          if (currentSegment.segmentCode === findSegment.segmentCode) {
            currentSegment.flightsNewInfo = fNInfo;

            // CI-22450: reutiliza el match ya resuelto para el currentSegment. El
            // lookup posterior por `segmentCode` exacto no encuentra nada cuando
            // Flight Status devuelve otra hora en el código (p. ej. ..._2155 vs
            // ..._2210) y dejaba `flightStatus` sin actualizar. No se amplía el
            // criterio de búsqueda: se aplica solo al segmento ya asociado.
            const mappedFlightStatus = FLIGHT_STATUS_BY_IROPS_STATUS[fNInfo.status];
            if (mappedFlightStatus) {
              this.reservation.flightSummary.flightStatus = mappedFlightStatus;
            }

            if (fNInfo.departureDateTime) {
              this.reservation.flightSummary.departureDateTime = fNInfo.departureDateTime;
              this.reservation.flightSummary.departureTime = fNInfo.departureDateTime.includes('T')
                ? fNInfo.departureDateTime.split('T')[1].substring(0, 5)
                : this.reservation.flightSummary.departureTime;

              // CI-21130: Reevaluar checkinStatus con el ETD actualizado de Flight Status
              const now = moment().local(true);
              const etd = moment(fNInfo.departureDateTime);
              const closingMinutes = this.reservation.flightSummary.isDomestic ? 45 : 60;
              const closingTime = moment(etd).subtract(closingMinutes, 'minutes');
              if (now.isBefore(closingTime)) {
                this.reservation.checkinStatus = CHECKIN_STATUS.OPEN;
                this.reservation.flightSummary.checkinStatus = CHECKIN_STATUS.OPEN;
              }
            }
          }

          // Se actualiza el segmento que coincida
          this.reservation.flightSummary.segments = this.reservation.flightSummary.segments.map(
            (seg) => (seg.segmentCode === findSegment.segmentCode ? findSegment : seg)
          );
        }
      }

      // CI-22450: se usa el mismo matcher determinista que arriba en lugar de una
      // segunda búsqueda por `segmentCode` exacto, que no encontraba nada cuando
      // Flight Status devuelve otra hora en el código y dejaba `flightStatus` sin
      // actualizar. La fuente es el currentSegment, no `flightStatusCollection[0]`.
      const cuSegment = matchFlightStatusForSegment(
        reservation?.flightSummary?.currentSegment,
        responseFlightStatus[i]?.flightStatusCollection ?? []
      ).entry;

      const flightStatus = cuSegment?.status;

      if (flightStatus) {
        reservation.flightSummary.flightStatus = FLIGHT_STATUS_BY_IROPS_STATUS[flightStatus];
      }
    }

    this._globalService.setReservation(this.reservation);
  }

  validStatusIrops(status) {
    const listStatusAfected = [IROPS_STATUS.DELAYED, IROPS_STATUS.EARLY, IROPS_STATUS.CANCELLED];

    return listStatusAfected.includes(status) ? status : IROPS_STATUS.SCHEDULED;
  }

  /**
  Carga la información de los pasajeros en espera (standby) y los detalles del vuelo para una reserva específica.
  Esta función realiza dos solicitudes simultáneas: una para obtener la lista de pasajeros en espera y otra para obtener
  los detalles del vuelo. Luego, procesa las respuestas y actualiza la información correspondiente en la reserva.

  @param reservation Un objeto de tipo `Reservation` que representa la reserva para la cual se cargarán los datos.
  @return Una promesa que se resuelve con `true` si ambas solicitudes son exitosas y se procesan correctamente.
**/

  loadStb(reservation: Reservation) {
    return new Promise((resolve) => {
      combineLatest([
        this._apiService.getPassengerListstandby(reservation),
        this._apiService.getFlightDetails(reservation),
      ])
        .pipe(take(1))
        .subscribe({
          next: ([successListStandby, successFlightDetail]) => {
            if (successListStandby) {
              this.successGetPassengerListstandby(successListStandby);
            }
            if (successListStandby && successFlightDetail) {
              this.successFlightDetail(successFlightDetail);
            }
            return resolve(true);
          },
          error: (error) => {
            this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
            return resolve(true);
          },
          complete: () => {},
        });
    });
  }

  /**
  Procesa la respuesta exitosa de la lista de pasajeros en espera (standby) y actualiza el estado de los pasajeros.
  Esta función filtra los pasajeros en espera que coinciden con el código de reserva (PNR) actual,
  @param response La respuesta recibida del servicio que contiene la lista de pasajeros en espera.
**/

  successGetPassengerListstandby(response) {
    if (!response.passengers) {
      response.passengers = [];
    }
    const passengers = response.passengers.filter(
      (pax) => pax.reservationCode === this.reservation.pnr
    );
    const passengerToSeleccion = this._globalService
      .getPassengers()
      .filter((x) => x.paxType !== PAX_TYPE.INFANT);
    if (passengers && passengers.length > 0) {
      for (let passenger of passengers) {
        const currentPassenger = passengerToSeleccion.find(
          (p) => p.passengerId === passenger.passengerId
        );
        if (currentPassenger) {
          currentPassenger.checkinStatus = true;
          currentPassenger.onPriorityCodeListOVS = true;
          this._globalService.setPassenger(currentPassenger);
        }
      }
    }
    this.reservation.flightSummary.pallTotalListed = response.totalListed;
  }

  /**
  Procesa la respuesta exitosa de los detalles de un vuelo y actualiza la información de los segmentos de la reserva.
  @param response La respuesta recibida del servicio que contiene los detalles del vuelo.
**/

  successFlightDetail(response) {
    let reponse = new FlightDetails(response);
    for (let segment of this.reservation.segments) {
      const segmentAct = reponse.bookedLegCollection.find(
        (p) => p.segmentCode === segment.segmentCode
      );
      if (segmentAct) {
        const cabinInfo = segmentAct.cabinInfoList.find((p) => p.classOfService === 'Y');
        segment.cabinInfo = cabinInfo;
        segment.flightStatus = segmentAct.flightStatus;
        this.reservation.flightSummary.boardingGate = segmentAct.departureGate;
      }
    }
  }

  openCodeInfoModal(operatingCarrier): void {
    const modalRef = this.modalService.open(AirLinesComponent, {
      centered: true,
      size: 'xl',
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.componentInstance.operatingCarrier = operatingCarrier;

    this.subscribeReference = modalRef.closed.subscribe(
      (resp) => {
        this._router.navigate(['/home']);
      },
      (error: ErrorInt) => {},
      () => {}
    );
  }

  ngOnDestroy() {
    this._keyboardServ.destroy();
  }

  validateToMenu() {
    const passegerList = this.reservation?.passengers.filter(
      (passenger) => passenger.hasInfant === false
    );
    // return passegerList.length <= 2 && passegerList.every((el) => el.checkinStatus);
    return passegerList.every((el) => el.checkinStatus);
  }
  /**
  Selecciona o deselecciona a todos los pasajeros que cumplen con ciertas condiciones para el check-in.
  Esta función itera sobre una lista de pasajeros filtrada y, dependiendo del valor proporcionado,
  selecciona o deselecciona a los pasajeros que están listos para el check-in o tienen un estado de check-in activo.
  Además, asigna la selección a los infantes asociados si corresponde.

  @param value Un valor booleano que indica si se deben seleccionar (`true`) o deseleccionar (`false`) a los pasajeros.
  @return No retorna ningún valor explícito, pero actualiza el estado de selección de los pasajeros y sus infantes asociados.
**/

  onSelectAllPaseengers(value) {
    if (value === true || value === false)
      for (const passenger of this.passengerToSeleccion.filter(
        (passenger) =>
          passenger.checkinStatus === true ||
          passenger.estatusCheckin === ESTATUS_CHECKIN.READY_FOR_CHECKIN
      )) {
        passenger.isSelectedToCheckin = value;
        passenger.checkinSelected = value;
        this.assingInfant(passenger);
      }
  }

  get passengerToSeleccion() {
    return this.reservation.passengers.filter((x) => x.paxType !== PAX_TYPE.INFANT);
  }
  /**
  Asigna la información de un adulto a su infante asociado en la reserva.
  @param adult Un objeto de tipo `Passenger` que representa al pasajero adulto del cual se obtendrá la información.
  @return No retorna ningún valor explícito, pero actualiza la información del infante en el servicio global.
**/
  assingInfant(adult: Passenger) {
    if (adult.hasInfant) {
      const { passengerId, passengerIds, checkinSelected } = adult;
      const infant = this.reservation.passengers.find(
        (inf) => inf.nameRefNumber === adult.passengerInfant
      );
      infant.checkinSelected = checkinSelected;
      infant.passengerId = passengerId;
      infant.passengerIds = passengerIds;
      this._globalService.setPassenger(infant);
    }
  }

  isSeamless(reservation: Reservation) {
    /**
     * Se usa WAIT_FOR_AGENT ya que no se tiene una bandera de seamless desarrollada y se tendría que solicitar a api
     * si esta bandera está en true permitira la validación de seamless de lo contrario lo debera saltar
     */
    if (this._adminService.admin.WAIT_FOR_AGENT)
      if (reservation?.flightSummary?.currentSegment?.marketingCarrier === 'AM') {
        const airline = AirLineSeamless.find(
          (airline) => airline === reservation.flightSummary.currentSegment.operatingCarrier
        );
        return !!airline;
      }
    return false;
  }

  async dispatchEligibilityIrops() {
    return lastValueFrom(
      this._iropsMicroService.eligibility(this.reservation, TypeLoading.FOOTER_LOADING)
    );
  }

  private isChildAlone(passengers): string | null {
    return verifyChildAlone(passengers) ? '/notice-child' : null;
  }

  validateVoidTicket(reservation: Reservation): boolean {
    const { segments, passengers } = reservation;
    const nonFlownStatuses: string[] = [
      CHECKIN_STATUS.CLOSED,
      CHECKIN_STATUS.IN_FLIGHT,
      CHECKIN_STATUS.FINAL,
      CHECKIN_STATUS.BOARDING,
    ];
    const activeSegments: Segment[] = segments.filter(
      (s: Segment) => !nonFlownStatuses.includes(s.windowSegmentStatus)
    );
    const segmentCodes: string[] = activeSegments.map((segment: Segment) => segment.segmentCode);
    const segLeng: number = activeSegments.length;

    return passengers.some(
      (p) =>
        p.ticketInfo?.coupons?.filter((c) => segmentCodes.includes(c.segmentCode))?.length !==
        segLeng
    );
  }

  validInternationalBlock(reservation: Reservation) {
    const blockInter = this._adminService.admin.TSA && !reservation.flightSummary.isDomestic;
    const blockInterRegions = this._adminService.admin.portPinpad;
    const segments = reservation.flightSummary.segments.filter(
      (seg) =>
        seg.windowSegmentStatus === CHECKIN_STATUS.CKI ||
        seg.windowSegmentStatus === CHECKIN_STATUS.MYB
    );
    const isBlock =
      blockInter && segments?.some((seg) => blockInterRegions.includes(seg.arrivalAirportRegion));
    return isBlock;
  }

  openModalInternationalBlocked(): void {
    const modalRef = this.modalService.open(TsaBlockerModalComponent, {
      centered: true,
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.componentInstance.lang = this._traslateService.currentLang.replace('-', '_');
    this.subscribeReference = modalRef.closed.subscribe((resp) => {
      this._router.navigate(['/home']);
    });
  }
  /**
   LOYATLY
   **/

  getAssosiateFFN(passenger: Passenger, reservation: Reservation) {
    this._loyatlyService.getAssosiateFFN(passenger, reservation).subscribe({
      next: (res) => {
        //let reponse = new RespBenefits(res);
      },
      error: (error) => {},
      complete: () => {},
    });
  }

  /**
   * Envía el remark de entrada al flujo IROPs si el pasajero es elegible (exchangesAllowed === true).
   * AC1: Se invoca al microservicio de remarks.
   * AC2: Si no es elegible, no se invoca.
   */
  private dispatchIropsRemarkIfEligible(): void {
    if (!this.respEligibleIrops || !this.respEligibleIrops.exchangesAllowed) {
      return;
    }

    const segmentCancelled = this.segCancelled;
    const segmentAfected = this.segAfected;
    let affectationType: string = 'MAJ';
    let action: string = 'IROPDL';

    if (segmentCancelled) {
      action = 'IROPCN';
      affectationType = 'CAN';
    } else if (segmentAfected) {
      const timeAfected = calculateIropsAffectationTime(segmentAfected);
      const totalMinutes: number = (timeAfected.hours || 0) * 60 + (timeAfected.minutes || 0);
      affectationType = totalMinutes <= 60 ? 'MIN' : 'MAJ';
    }

    this._iropsMicroService.affectationType = affectationType;

    const remarkParams = IropsMapper.buildRemarkParams(this.reservation, action, affectationType);
    this._iropsMicroService.sendIropsRemark(this.reservation, remarkParams).subscribe();
  }

  /**
   * Validacion pasajeros sin passengerIds desde viewdocuments
   */
  private hasNoPassengerIdsForAllPassengers(viewDocsResponse: any): boolean {
    if (this.reservation?.codeShare) {
      return false;
    }
    const passengers = viewDocsResponse?.passengers || [];
    if (!passengers.length) {
      return false;
    }
    return passengers.every((p) => !Array.isArray(p?.passengerIds) || p.passengerIds.length === 0);
  }
  /**
   * Si ningún pasajero de la reserva trae passengerIds,
   * se muestra modal de “acude a mostrador” y se termina el flujo actual.
   */
  private handleMissingPassengerIdsBlock(): boolean {
    if (!this.shouldBlockByMissingPassengerIds) {
      return false;
    }
    this._message
      .errorNoCkin(
        {
          typesError: TypesErrors.CHECKIN_ERROR,
          error: {
            message: '',
          },
        },
        null,
        TypesErrors.CHECKIN_ERROR,
        messageNoCkn,
        '',
        false
      )
      .finally(() => {
        this._router.navigate(['']);
      });
    this.ngOnDestroy();
    return true;
  }

  /**
   * Modal mostrado,
   * luego en el .finally() de la promesa se navega y se destruye el servicio.
   */
  private handleFareFamilyEmptyError(): void {
    this._message
      .error(
        {
          typesError: TypesErrors.FARE_FAMILY_EMPTY_ERROR,
          error: new ErrorModel({ message: '' }),
        },
        '',
        TypesErrors.FARE_FAMILY_EMPTY_ERROR,
        messageFareFamilyEmpty
      )
      .finally(() => {
        this._router.navigate(['']);
        this.ngOnDestroy();
      });
  }

  private openModalErrorDocuments() {
    this._message
      .errorNoCkin(
        {
          typesError: TypesErrors.CHECKIN_ERROR,
          error: {
            message: '',
          },
        },
        null,
        TypesErrors.CHECKIN_ERROR,
        messageNoCkn,
        '',
        false
      )
      .finally(() => {
        this._router.navigate(['']);
      });
  }

  private hasPassengersFFN(passenger: Passenger) {
    return (
      (passenger.frequentFlyerNumber && passenger.frequentFlyerProgram) ||
      (passenger.passengerInfo.ffNumber && passenger.passengerInfo.ffProgram)
    );
  }
}
